import type { ChatMessengerElement } from '@/types/chat-messenger';

/**
 * Sends `PROVIDE_RECOMMENDATION: <productName>` to the CX agent via the
 * chat-messenger presenter. No-ops if the chat-messenger is not mounted or
 * `productName` is empty, so it is safe to call from any add-to-cart path.
 */
export const sendCXProvideRecommendationEvent = (productName: string | undefined): void => {
  if (!productName) return;
  const messenger = document.querySelector('chat-messenger') as ChatMessengerElement | null;
  messenger?.presenter?.sendEvent?.(`PROVIDE_RECOMMENDATION: ${productName}`);
};
